import { auth } from "@/services";

/**
 * Nestable sidebar link item
 *
 * @returns {Object} direcive config
 */
function adminSidebarLinkDirective() {
  function adminSidebarLinkController($scope) {
    /**
     * Toggles visiblity of any child links
     */
    function handleClick(event) {
      event.stopPropagation();
      const children = $scope.link.children;
      if (children && children.length) {
        event.preventDefault();
        $scope.expanded = !$scope.expanded;
        return false;
      }
    }

    /**
     * Determines whether a child of this link is the selected route
     *
     * @returns {Boolean}
     */
    function hasSelectedChildLink() {
      const selectedRouteName = $scope.selectedRouteName;

      /**
       * Reducer function that returns true if the item is the current route.
       * Otherwise recursively calls items for all child items.
       *
       * @param {Boolean} selected
       * @param {Object} item
       */
      function childSelectedReducer(selected, item) {
        if (selected) {
          return true;
        }

        if (item.routeName === selectedRouteName) {
          return true;
        }

        if (item.children && item.children.length) {
          return checkChildren(item.children);
        }

        return false;
      }

      /**
       * Checks whether any items are the selected route
       * (checks recursively through any children)
       *
       * @param {*} children
       */
      function checkChildren(children) {
        return children.reduce(childSelectedReducer, false);
      }

      return checkChildren($scope.link.children);
    }

    /**
     * Builds object of classes for the root <li> element
     *
     * @returns {Object}
     */
    function buildNgClass() {
      return {
        "__has-children": $scope.link.children && $scope.link.children.length,
        __expanded: $scope.expanded,
        __active: $scope.selectedRouteName === $scope.link.routeName,
      };
    }

    // properties
    $scope.linkDepth = $scope.linkDepth || 0;
    $scope.expanded = hasSelectedChildLink();
    const user = auth.user();
    $scope.user = user && user.data;
    // methods
    $scope.handleClick = handleClick;
    $scope.buildNgClass = buildNgClass;
  }

  return {
    restrict: "E",
    templateUrl: "directives/admin/admin-sidebar-link.html",
    link: adminSidebarLinkController,
    scope: {
      link: "=", // { label, url, routeName, childLinks }
      linkDepth: "@", // default = 0
      selectedRouteName: "@", // active if matches link.routeName
    },
  };
}

angular.module("app").directive("adminSidebarLink", adminSidebarLinkDirective);
